import {Grid, Typography, withStyles} from '@material-ui/core'
import {Visibility} from '@material-ui/icons'

import React, {Component} from 'react'
import {connect} from 'react-redux'
import CollectionCrud from '../../common/Components/CollectionCrud'
import SignaturesCss from './css/SignaturesCss'
import { collectionActions, updateFormulaireMark } from '../../../reducers/collectionsReducer'
import CheckboxInput from "../../common/Components/CheckboxInput"

class Signatures extends Component {
  state = {
    selectedSejour: null,
  }

  componentDidMount() {
  }

  getDateTime(string) {
    if (!string) {
      return ''
    }
    let date = new Date(string)
    let options = {day: 'numeric', month: 'numeric', year: 'numeric'}
    return date.toLocaleTimeString('fr-FR', options)
  }

  getDate(string) {
    if (!string) {
      return ''
    }
    let date = new Date(string)
    let options = {day: 'numeric', month: 'numeric', year: 'numeric'}
    return date.toLocaleDateString('fr-FR', options)
  }

  signatureLink(line) {
    // en dev, remplacer le :3000 de l'url par :8000
    let p = line.uuid.split('_')
    return '/souhaits/formulaire_' + p[1]
  }

  markClickHandler(line) {
    updateFormulaireMark(
      this.props.dispatch, line.uuid, {
        is_marked: !line.is_marked,
      }
    )
  }

  getActionsButtons(line) {
    const {classes} = this.props

    var btns = []

    btns.push(
      <a
        key="link"
        title="Voir le formulaire signé"
        href={this.signatureLink(line)}
        className={classes.signatureLink}
        target='_blank'
        rel="noopener noreferrer"
      >
        <Visibility/>
      </a>
    )
    return btns
  }

  getMarkButton(line) {
    return (
      <CheckboxInput
          id='is_marked'
          value={line.is_marked}
          name='is_marked'
          onChangeHandler={this.markClickHandler.bind(this, line)}
      />
    )
  }

  loadAsyncData(paginationFilters) {
    let { dispatch, signaturesStore } = this.props;

    if (signaturesStore.fetching) return;

    // const { filters } = this.state;

    // const { type_filter, assigned_to_filter, closed_filter, commercial_filter } = filters;

    if(paginationFilters) {
      // eslint-disable-next-line
      this.state.paginationFilters = paginationFilters;
    }

    var data_params = {};
    data_params.params = {
      ...this.state.paginationFilters,
      // entreprise_uuid: entreprise_uuid ? entreprise_uuid : null,
    };

    // Gardes fou pour éviter que des requêtes partent sans pagination
    if (!data_params.params.oniti_pagination) {
      data_params.params.oniti_pagination = 1;
    }
    if (!data_params.params.oniti_perpage) {
      data_params.params.oniti_perpage = 25;
    }

    return collectionActions(
      dispatch,
      "signatures",
      "INDEX",
      data_params,
      null,
      true
    );
  }


  render() {
    const {classes} = this.props

    return (
      <Grid container spacing={2} className={classes.container}>
        <Typography
          variant="button"
          gutterBottom
          className={classes.sectionTitle}
        >
          Derniers formulaires signés
        </Typography>

        <CollectionCrud
          collectionName={'signatures'}
          loadDatas={false}
          showBtnEdit={false}
          showBtnAdd={false}
          showBtnDelete={false}
          asynchrone={true}
          asynchroneCallbackLoadData={this.loadAsyncData.bind(this)}
          datatableConfig={{
            showPagination: true,
            showSearch: true,
            rowsPerPageOptions: [20, 50, 100],
            defaultSort: "signature_date",
            sortType: "asc",
          }}
          cellsConfig={[
            {
              datakey: 'signature_date',
              title: 'Date signature',
              sortable: true,
              searchable: true,
              format: (obj, key) => {
                return this.getDateTime(obj[key])
              },
            },
            {
              datakey: 'enfant_nom',
              title: 'Nom enfant',
              sortable: true,
              searchable: true,
            },
            {
              datakey: 'enfant_prenom',
              title: 'Prénom',
              sortable: true,
              searchable: true,
            },
            {
              datakey: 'sejours.libelle', // pas un vrai champ !
              title: 'Séjour',
              sortable: true,
              searchable: true,
              format: (obj, key) => {
                return obj.sejour.libelle + ' (' + obj.sejour.identifiant + ')'
              },
            },
            {
              title: 'Marqué',
              format: this.getMarkButton.bind(this),
              sortable: false,
            },
            {
              format: this.getActionsButtons.bind(this),
              sortable: false,
            },
          ]}
        />
      </Grid>
    );
  }
}

Signatures = withStyles(SignaturesCss)(Signatures)

Signatures = connect((store) => {
  return {
    signaturesStore: store.collections.signatures,
  }
})(Signatures);

export default Signatures
